export enum Device {
    PC = 'pc',
    MOBILE = 'mobile',
}
